import { LensTwoTone } from '@mui/icons-material';
import { Storage } from 'aws-amplify';
import React, { useEffect, useState } from "react";
import * as pako from 'pako';

import yaml from 'js-yaml';
import Papa from 'papaparse';

export async function getGZGeoJsonFromS3(filepath, user, fileInsightsDataCache, setFileInsightsDataCache) {
  // If this file has been downloaded before, use the cached data
  if (fileInsightsDataCache.has(filepath)) {
    return fileInsightsDataCache.get(filepath);
  }
  try {
    const signedUrl = await Storage.get(filepath, { download: false, customPrefix: { public: '' } });
    const response = await fetch(signedUrl);
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Read the response data as a binary blob
    const blob = await response.blob();

    // Create a FileReader to read the blob data as an ArrayBuffer
    const reader = new FileReader();
    const promise = new Promise((resolve, reject) => {
      reader.onloadend = () => {
        // Use pako to decompress the data    
        const typedArray = new Uint8Array(reader.result);
        const decompressed = pako.ungzip(typedArray, { to: "string" });
        const jsonData = JSON.parse(decompressed);
        resolve(jsonData);
      };
      reader.onerror = reject;
    });
    reader.readAsArrayBuffer(blob);

    const jsonData = await promise;

    const filepath_split = filepath.split('/');
    const bucket = filepath_split[0];
    const vineyard = filepath_split[1]
    const date = filepath_split[3];

    // Generate pre-signed URLs for the images
    for (let feature of jsonData.features) {
      const oneWeekInSeconds = 60 * 60 * 24 * 7;
      let subdir = '/vo180'

      let imageUrl;
      if (feature.properties.img_names_trunk_vo180 !== null) {
        imageUrl = await Storage.get(`${bucket}/${vineyard}/raw_data/${date}/images_hub${subdir}/${feature.properties.img_names_trunk_vo180}`, { expires: oneWeekInSeconds, download: false, customPrefix: { public: '' } });
      } else {
        imageUrl = await Storage.get(`${bucket}/${vineyard}/raw_data/${date}/images_hub${subdir}/${feature.properties.img_names_trunk_vo0}`, { expires: oneWeekInSeconds, download: false, customPrefix: { public: '' } });
      } 
      
      feature.properties.imageUrl = imageUrl;
    }

    // After successfully downloading and processing the data, store it in the cache
    fileInsightsDataCache.set(filepath, jsonData);
    setFileInsightsDataCache(new window.Map(fileInsightsDataCache)); // Clone the Map to force a re-render

    return jsonData;

  } catch (error) {
    console.log('Error getting GeoJSON from S3:', error);
    return null;
  }
};

export async function getGZJsonFromS3(filepath, user, fileInsightsDataCache, setFileInsightsDataCache) {
  // If this file has been downloaded before, use the cached data
  if (fileInsightsDataCache.has(filepath)) {
    return fileInsightsDataCache.get(filepath);
  }
  try {
    const signedUrl = await Storage.get(filepath, { download: false, customPrefix: { public: '' } });
    const response = await fetch(signedUrl);
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Read the response data as a binary blob
    const blob = await response.blob();

    // Create a FileReader to read the blob data as an ArrayBuffer
    const reader = new FileReader();
    const promise = new Promise((resolve, reject) => {
      reader.onloadend = () => {
        // Use pako to decompress the data    
        const typedArray = new Uint8Array(reader.result);
        const decompressed = pako.ungzip(typedArray, { to: "string" });
        const jsonData = JSON.parse(decompressed);
        resolve(jsonData);
      };
      reader.onerror = reject;
    });
    reader.readAsArrayBuffer(blob);

    const jsonData = await promise;

    // After successfully downloading and processing the data, store it in the cache
    fileInsightsDataCache.set(filepath, jsonData);
    // setFileInsightsDataCache(new window.Map(fileInsightsDataCache)); // Clone the Map to force a re-render
    console.log('Successfully retrieved plant asset table from S3')
    return jsonData;

  } catch (error) {
    console.log('Error getting JSON from S3:', error);
    return null;
  }
};

export async function getGeoJsonFromS3(filepath, user, fileBlocksDataCache, setFileBlocksDataCache) {
  // If this file has been downloaded before, use the cached data
  if (fileBlocksDataCache.has(filepath)) {
    return fileBlocksDataCache.get(filepath);
  }
  try {
    const signedUrl = await Storage.get(filepath, { download: false, customPrefix: { public: '' } });
    const response = await fetch(signedUrl);
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const jsonData = await response.json();
    const filepath_split = filepath.split('/');
    const bucket = filepath_split[0];
    const vineyard = filepath_split[1];
    const date = filepath_split[3];

    // Generate pre-signed URLs for the images
    for (let feature of jsonData.features) {
      const oneWeekInSeconds = 60 * 60 * 24 * 7;
      let subdir = '/vo180'
      let imageUrl;
      if (feature.properties.img_names_trunk_vo180 !== null) {
        imageUrl = await Storage.get(`${bucket}/${vineyard}/raw_data/${date}/images_hub${subdir}/${feature.properties.img_names_trunk_vo180}`, { expires: oneWeekInSeconds, download: false, customPrefix: { public: '' } });
      } else {
        imageUrl = await Storage.get(`${bucket}/${vineyard}/raw_data/${date}/images_hub${subdir}/${feature.properties.img_names_trunk_vo0}`, { expires: oneWeekInSeconds, download: false, customPrefix: { public: '' } });
      } 
      
      feature.properties.imageUrl = imageUrl;
    }

    // After successfully downloading and processing the data, store it in the cache
    fileBlocksDataCache.set(filepath, jsonData);
    setFileBlocksDataCache(new window.Map(fileBlocksDataCache)); // Clone the Map to force a re-render

    return jsonData;

  } catch (error) {
    console.log('Error getting GeoJSON from S3:', error);
    return null;
  }
}

export async function getPresignedJsonFromS3(filepath, user, fileBlocksDataCache, setFileBlocksDataCache) {
  // If this file has been downloaded before, use the cached data
  if (fileBlocksDataCache.has(filepath)) {
    return fileBlocksDataCache.get(filepath);
  }
  try {
    const signedUrl = await Storage.get(filepath, { download: false, customPrefix: { public: '' } });
    const response = await fetch(signedUrl);
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const jsonData = await response.json();
    const filepath_split = filepath.split('/');
    const bucket = filepath_split[0];
    const vineyard = filepath_split[1];

    console.log('jsonData', jsonData);

    // Generate pre-signed URLs for the images
    for (let feature of jsonData.features) {
      console.log('feature here', feature.properties.File);
      const oneWeekInSeconds = 60 * 60 * 24 * 7;
      const imageUrl = await Storage.get(`${bucket}/${vineyard}/infrastructure/images/${feature.properties.File}`, { expires: oneWeekInSeconds, download: false, customPrefix: { public: '' } });
      feature.properties.imageUrl = imageUrl;
    }

    // After successfully downloading and processing the data, store it in the cache
    fileBlocksDataCache.set(filepath, jsonData);
    setFileBlocksDataCache(new window.Map(fileBlocksDataCache)); // Clone the Map to force a re-render

    return jsonData;

  } catch (error) {
    console.log('Error getting GeoJSON from S3:', error);
    return null;
  }
}


export async function getJsonFromS3(filepath, user, fileBlocksDataCache, setFileBlocksDataCache, presignUrls = false) {
  // If this file has been downloaded before, use the cached data
  if (fileBlocksDataCache.has(filepath)) {
    return fileBlocksDataCache.get(filepath);
  }
  try {
    const signedUrl = await Storage.get(filepath, { download: false, customPrefix: { public: '' } });
    const response = await fetch(signedUrl);
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const jsonData = await response.json();
    const filepath_split = filepath.split('/');
    const bucket = filepath_split[0];
    const vineyard = filepath_split[1];

    // Generate pre-signed URLs for the images
    if (presignUrls === true) {

      for (let feature of jsonData.features) {
        const oneWeekInSeconds = 60 * 60 * 24 * 7;
        const imageUrl = await Storage.get(`${bucket}/${vineyard}/infrastructure/${feature.properties.Files}`, { expires: oneWeekInSeconds, download: false, customPrefix: { public: '' } });
        feature.properties.imageUrl = imageUrl;
      }
    };

    // After successfully downloading and processing the data, store it in the cache
    fileBlocksDataCache.set(filepath, jsonData);
    setFileBlocksDataCache(new window.Map(fileBlocksDataCache)); // Clone the Map to force a re-render

    return jsonData;

  } catch (error) {
    console.log('Error getting GeoJSON from S3:', error);
    return null;
  }
}


export async function getGZSummaryTableFromS3(filepath) {
  try {
    const signedUrl = await Storage.get(filepath, { download: false, customPrefix: { public: '' } });
    const response = await fetch(signedUrl);
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Read the response data as a binary blob
    const blob = await response.blob();

    console.log('blob', blob);

    // Create a FileReader to read the blob data as an ArrayBuffer
    const reader = new FileReader();
    const promise = new Promise((resolve, reject) => {
      reader.onloadend = () => {
        // Use pako to decompress the data    
        const typedArray = new Uint8Array(reader.result);
        const decompressed = pako.ungzip(typedArray, { to: "string" });
        const parsedCsv = Papa.parse(decompressed, { header: true, dynamicTyping: true });
        resolve(parsedCsv.data);
      };
      reader.onerror = reject;
    });
    reader.readAsArrayBuffer(blob);

    const tableData = await promise;

    return tableData

  } catch (error) {
    console.log('Error getting gzipped CSV file from S3:', error);
    return null;
  }
}

export async function listDataCollectionDates(bucket, vineyard) {
  try {

    console.log('bucket here', bucket)
    console.log('vineyard here', vineyard)

    const response_test = await Storage.get(`${bucket}/_metadata.yaml`, { customPrefix: {public: '' }});
    const response_fetched = await fetch(response_test);
    const response_text = await response_fetched.text();
    const yaml_test = await yaml.load(response_text);
    const dates = Object.values(yaml_test)[0][vineyard]

    return dates;
    
  }
  catch (error) {
    console.log('Error listing subdirectories:', error);
    return [];
  }
}

export async function listDataVineyards(bucket) {
  try {
    console.log('bucket here', bucket)

    const response_test = await Storage.get(`${bucket}/_metadata.yaml`, { customPrefix: {public: '' }});
    const response_fetched = await fetch(response_test);
    const response_text = await response_fetched.text();
    const yaml_test = await yaml.load(response_text);
    const vineyards = Object.keys(Object.values(yaml_test)[0]);

    return vineyards;
    
  }
  catch (error) {
    console.log('Error listing subdirectories:', error);
    return [];
  }
}

export function GetTooltipImageFromS3({ object, userGroup, selectedInsightMetric, selectedInsightMetricName, selectedDate }) {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (object.properties.img_names_trunk_vo180 !== null) {
      setImageUrl(object.properties.img_names_trunk_vo180);
    } else if (object.properties.img_names_trunk_vo0 !== null) {
      setImageUrl(object.properties.img_names_trunk_vo0);
    } else {
      setImageUrl(null);
    }
  }, [object]);

  return (
    <div>
      <b>{selectedInsightMetric}: {object.properties[selectedInsightMetricName].toFixed(0)}</b><br />
      {imageUrl ? <img src={imageUrl} width='163' height='300' /> : null}
    </div>
  );
}

